import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"max-height":"835px"},
  class: "h-100"
}
const _hoisted_2 = {
  key: 0,
  id: "prescription-image-component",
  style: {"resize":"both","z-index":"100"},
  class: "h-100"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "File not found", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "no-image" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("i", null, "No RX Loaded")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "no-image" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("i", null, "No image loaded in this prescription.")
  ])
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_img = _resolveComponent("b-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.imageID || _ctx.escriptID))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", {
            id: _ctx.pdfContainerID,
            class: "no-image h-100"
          }, _hoisted_5, 8, _hoisted_3), [
            [_vShow, !_ctx.imageSrc]
          ]),
          (_ctx.imageSrc)
            ? (_openBlock(), _createBlock(_component_b_img, {
                key: 0,
                style: {"overflow":"auto","height":"100%"},
                src: _ctx.imageSrc,
                fluid: "",
                thumbnail: ""
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]))
      : (!_ctx.rxNumber)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ]))
}